import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { apiUrl } from "../../../../../ApiHelper/ApiUrl";
import { callApi } from "../../../../../ApiHelper/ApiHelper";
import ErrorMessage from "../../../../../components/comman/ErrorMessage";
import { Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { errorTypes } from "../../../../../utility/InputValidation";

export default function EmployeeAddressDetails({
  locationData,
  pageStatesMain,
  setPageStatesMain,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const statesData = [
    "Andaman and Nicobar Islands",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chandigarh",
    "Chhattisgarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Ladakh",
    "Lakshadweep",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Puducherry",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];

  useEffect(() => {
    if (locationData) {
      reset({
        address: locationData?.userdetail?.address || "",
        state: locationData?.userdetail?.state || "",
        city: locationData?.userdetail?.city || "",
        pinCode: locationData?.userdetail?.pinCode || "",
        permanentAddress: locationData?.userdetail?.permanentAddress || "",
        permanentState: locationData?.userdetail?.permanentState || "",
        permanentCity: locationData?.userdetail?.permanentCity || "",
        permanentPinCode: locationData?.userdetail?.permanentPinCode || "",
      });
    }
  }, []);

  const onSubmit = (data) => {
    // console.log("submitData>>>>>>>>>>", data);
    const formData = new FormData();
    formData.append("address", data?.address);
    formData.append("state", data?.state);
    formData.append("city", data?.city);
    formData.append("pinCode", data?.pinCode);
    formData.append("permanentAddress", data?.permanentAddress);
    formData.append("permanentState", data?.permanentState);
    formData.append("permanentCity", data?.permanentCity);
    formData.append("permanentPinCode", data?.permanentPinCode);
    formData.append("activeTab", "Address Details");

    const options = {
      method: "POST",
      form_data: formData,
    };
    let API =
      apiUrl?.add_employee +
      `?userId=${locationData?.id ? locationData?.id : pageStatesMain?.Id_onCreateEmp
      }`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        setPageStatesMain((prev) => ({
          ...prev,
          activeTab: 5,
        }));
      } else {
        toast.error(response?.message);
      }
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col-12 col-lg-6">
          <div className="row">
            <div className="col-12">
              <div className="my-3 border-bottom pb-3 d-flex align-items-center justify-content-between">
                <h4 className="fs-3 m-0 rajdhani-semibold">Present Address</h4>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group mb-3">
                <label htmlFor="Address" className="form-label">
                  Address
                  <span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  id="Address"
                  rows={3}
                  defaultValue={""}
                  {...register("address", {
                    ...errorTypes.required("Address"),
                  })}
                />
                <ErrorMessage message={errors?.address?.message} />
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div className="form-group mb-3">
                <label htmlFor="state" className="form-label">
                  State <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select form-control"
                  {...register("state", {
                    ...errorTypes.required("State")
                  })}
                >
                  <option value="" className="d-none">
                    Select State
                  </option>
                  {statesData?.map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
                <ErrorMessage message={errors?.state?.message} />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group mb-3">
                <label htmlFor="city" className="form-label">
                  City <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="Pincode"
                  placeholder="Enter City"
                  maxLength={160}
                  {...register("city", {
                    ...errorTypes.required("City"),
                  })}
                />
                <ErrorMessage message={errors?.city?.message} />
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div className="form-group mb-3">
                <label htmlFor="Pincode" className="form-label">
                  Pin Code <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="Pincode"
                  placeholder="Enter Pin Code"
                  {...register("pinCode", {
                    ...errorTypes.required("Pin code"),
                    ...errorTypes.pincode("Pin code")
                  })}
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Allow only digits (0-9)
                  }}
                />
                <ErrorMessage message={errors?.pinCode?.message} />
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6">
          <div className="row">
            <div className="col-12">
              <div className="my-3 border-bottom pb-3 d-flex align-items-center justify-content-between">
                <h4 className="fs-3 m-0 rajdhani-semibold">Permanent Address</h4>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="presentAdd"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setValue("permanentAddress", watch("address"));
                        setValue("permanentState", watch("state"));
                        setValue("permanentCity", watch("city"));
                        setValue("permanentPinCode", watch("pinCode"));
                      } else {
                        setValue("permanentAddress", "");
                        setValue("permanentState", "");
                        setValue("permanentCity", "");
                        setValue("permanentPinCode", "");
                      }
                    }}
                  />
                  <label className="form-check-label fs-4" htmlFor="presentAdd">
                    Same as present address
                  </label>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group mb-3">
                <label htmlFor="Address" className="form-label">
                  Address
                  <span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  id="Address"
                  rows={3}
                  defaultValue={""}
                  {...register("permanentAddress", {
                    ...errorTypes.required("Address"),
                  })}
                />
                <ErrorMessage message={errors?.permanentAddress?.message} />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group mb-3">
                <label htmlFor="Role" className="form-label">
                  State <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select form-control"
                  aria-label="Default select example"
                  {...register("permanentState", {
                    ...errorTypes.required("State")
                  })}
                >
                  <option value="" className="d-none">
                    Select State
                  </option>
                  {statesData?.map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
                <ErrorMessage message={errors?.permanentState?.message} />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group mb-3">
                <label htmlFor="Role" className="form-label">
                  City <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="Pincode"
                  placeholder="Enter City"
                  maxLength={160}
                  {...register("permanentCity", {
                    ...errorTypes.required("City"),
                  })}
                />
                <ErrorMessage message={errors?.permanentCity?.message} />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group mb-3">
                <label htmlFor="Pincode" className="form-label">
                  Pin Code <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  className="form-control"
                  id="Pincode"
                  placeholder="Enter Pin Code"
                  {...register("permanentPinCode", {
                    ...errorTypes.required("Pin code"),
                    ...errorTypes.pincode("Permanent Pin code")
                  })}
                />
                <ErrorMessage message={errors?.permanentPinCode?.message} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-end">
        <button className="btn btn-primary px-4" type="submit">
          {isLoading ? <Spinner /> : "Save and Continue"}
        </button>
      </div>
    </form>
  );
}
